import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import HowToRegIcon from "@material-ui/icons/HowToReg";
import NoticeModal from "views/components/NoticeModal";
import ConfirmationModal from "views/components/ConfirmationModal";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import WeighageControllerCreate from "./WeighageControllerCreate";

const WeighageController = ({classes}) => {
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([
    { id: "id", label: "ID" },
    { id: "param", label: "Param" },
    { id: "weightage", label: "Weightage" },
    { id: "action", label: "Actions" },
  ]);
  const [templateData, setTemplateData] = useState(["PinCodes"]);
  const [rawData, setRawData] = useState([]);
  const [noticeModal, setNoticeModal] = useState(false);
  const [noticeModalErrMsg, setNoticeModalErrMsg] = useState("");
  const [noticeModalHeaderMsg, setNoticeModalHeaderMsg] = useState("");
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteWeighage, setDeleteWeighage] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [weighageControllerShow, setWeighageControllerShow] = useState(true);
  const handleWeighageCreate = async () => {
    setWeighageControllerShow(false);
  };

  useEffect(() => {
    GetData();
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_WEIGHTAGE_CONTROLLER_FIND,
      authToken: authToken,
    });
    setCallInProgress(false);

    if (result?.data?.error_code) {
      setNoticeModalErrMsg(result?.data?.user_description);
      setNoticeModalHeaderMsg("Error");
      setNoticeModal(true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data);
    }
  };

  const parseIndicatorData = (data) => {
    let reportData = [];
    data.forEach((weightage, i) => {
      if(weightage?.status !==  "EXHAUSTED"){
      let row = {
        id: weightage.id,
        param: weightage.param,
        weightage: weightage.weightage,
        action: getIcons(weightage.id),
      };
      reportData.push(row);}
    });
    setSelectedTableData(reportData);
  };
  // icons function calling
  const getIcons = (code,) => {
    return (
      <>
        <IconButton
          aria-label="Edit_Weightage"
          onClick={() => onClickUpdateData(code)}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="Delete_Weightage"
          onClick={() => onClickDeleteData(code)}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };
  const onClickUpdateData = (code) => {
    setDeleteWeighage(code);
    setWeighageControllerShow(false);
  };
  // delete function
  const onClickDeleteData = (id) => {
    setConfirmationModalHeader("Weightage Controller");
    setConfirmationModalMsg("Are you sure you want to delete this entry");
    setDeleteWeighage(id);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteWeighage("");
  };

  const handlePositiveResponse = async () => {
    handleNegativeResponse();
    // Call API to delete Branch
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.MASTER_WEIGHTAGE_CONTROLLER_DELETE + deleteWeighage,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      setNoticeModalErrMsg(res?.data?.user_description);
      setNoticeModalHeaderMsg("Error");
      setNoticeModal(true);
    } else {
      setNoticeModalErrMsg("Weightage deleted successful");
      setNoticeModalHeaderMsg("Success");
      setNoticeModal(true);
      GetData();
    }
  };

  const onCloseModal = (type) => {
    if (type === "create") {
      setNoticeModalErrMsg("Weightage Successfully Allocated!");
      setNoticeModalHeaderMsg("Information");
      setNoticeModal(true);
    } else {
      setNoticeModalErrMsg("Weightage updated successfully");
      setNoticeModalHeaderMsg("Information");
      setNoticeModal(true);
    }
    GetData();
  };
  // search function calling
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      return (
        row.param.toLowerCase().includes(val.toLowerCase()) 
      );
    });
    parseIndicatorData(filteredData);
  };
  // message popup
  const closeNoticeModal = () => {
    setNoticeModal(false);
    setNoticeModalErrMsg("");
    setNoticeModalHeaderMsg("");
  };
  return (
    <GridContainer>
      {weighageControllerShow  ? (
        <>
          <GridItem xs={12} sm={12} md={12}>
            <SubHeader
              label="Weightage"
              button1="ADD"
              button1click={handleWeighageCreate}
              onSearchChange={onSearchChange}
              searchLabel="Search For Weightage"
              search
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <ColumnGroupingTable
              columns={tableColumns}
              rows={selectedTableData}
            />
          </GridItem>
        </>
      ) : (
        <>
          {!weighageControllerShow && (
            <WeighageControllerCreate
            WeighageAllocationShow={setWeighageControllerShow}
            weighageId={deleteWeighage}
              setWeighageId={setDeleteWeighage}
              classes={classes}
              onClose={onCloseModal}
              rawData={rawData}
            />
          )}
        
        </>
      )}
      <NoticeModal
        noticeModal={noticeModal}
        noticeModalHeader={noticeModalHeaderMsg}
        noticeModalErrMsg={noticeModalErrMsg}
        closeModal={closeNoticeModal}
      />
      {callInProgress && <CircularProgress callInProgress={callInProgress} />}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
    </GridContainer>
  );
};

WeighageController.propTypes = {
  classes: PropTypes.object,
};

export default WeighageController;
